import { useEffect } from "react";

import { selectCurrentUserUsername } from "Reducers/app/selectors";
import { loadEnvironments, environmentsSelector } from "Reducers/environment";
import { gitProjectSelector } from "Reducers/project/project";
import { useAppDispatch, useAppSelector } from "Store/hooks";

const useEnvironments = (projectId: string) => {
  const organizationId = useAppSelector(selectCurrentUserUsername);
  const project = useAppSelector(state =>
    gitProjectSelector(state, {
      organizationId,
      projectId
    })
  );
  const environments = useAppSelector(state =>
    environmentsSelector(state, { organizationId, projectId })
  );

  const environmentsArray = Object.values(environments ?? {});

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (project?.id && environmentsArray.length === 0) {
      dispatch(loadEnvironments({ projectId: project.id, organizationId }));
    }
  }, [dispatch, environmentsArray.length, organizationId, project?.id]);

  return environmentsArray.length > 0 ? environments : undefined;
};

export default useEnvironments;
